/**
 * lobbyLoadoutPersistence — Local lobby loadout save/restore (SPY-115).
 * Presentation: localStorage I/O only; session mutations via domain API.
 */

export const LOBBY_LOADOUT_STORAGE_KEY = 'lol_lobby_loadout';

/**
 * @param {object} session
 * @returns {{
 *   championId: string,
 *   mapId: string,
 *   spell1: string,
 *   spell2: string,
 *   runePage: string,
 *   masteryPage: string
 * }|null}
 */
export function serializeLobbyLoadout(session) {
  if (!session) return null;
  return {
    championId: session.selectedChampionId,
    mapId: session.selectedMapId,
    spell1: session.spell1,
    spell2: session.spell2,
    runePage: session.runePage,
    masteryPage: session.masteryPage
  };
}

/**
 * @param {object} session
 * @param {object|null|undefined} data
 * @returns {boolean}
 */
export function applyLobbyLoadout(session, data) {
  if (!session || !data || typeof data !== 'object') return false;
  let applied = false;
  if (data.championId && session.selectChampion(data.championId)) applied = true;
  if (data.mapId && session.selectMap(data.mapId)) applied = true;
  if (data.spell1 && data.spell2
    && session.setSummonerSpells(data.spell1, data.spell2)) {
    applied = true;
  }
  if (data.runePage && session.setRunePage(data.runePage)) applied = true;
  if (data.masteryPage && session.setMasteryPage(data.masteryPage)) applied = true;
  return applied;
}

/**
 * @param {{ getItem?: Function }|null} storage
 * @returns {object|null}
 */
export function readLobbyLoadout(storage) {
  if (!storage || typeof storage.getItem !== 'function') return null;
  try {
    const raw = storage.getItem(LOBBY_LOADOUT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return parsed;
  } catch {
    return null;
  }
}

/**
 * @param {{ setItem?: Function }|null} storage
 * @param {object|null} loadout
 * @returns {boolean}
 */
export function writeLobbyLoadout(storage, loadout) {
  if (!storage || typeof storage.setItem !== 'function' || !loadout) return false;
  try {
    storage.setItem(LOBBY_LOADOUT_STORAGE_KEY, JSON.stringify(loadout));
    return true;
  } catch {
    return false;
  }
}
